import React, { Component } from "react";
import { connect } from "react-redux";
import { updateGlobalErrorMessage } from "../../../actions/globalError";
import {
  updateCurrentMenu,
  updateRecurringAppointmentConfirmationModalVisibility
} from "../../../actions/menu";
import { Modal } from "semantic-ui-react";
import {
  updateBooking,
  splitRecurringAppointment
} from "../../../actions/booking";
import {
  toApiDateTime,
  convertApiUtcToLocalMoment,
  convertTimeFromApi,
  convertDateTimeFromApi
} from "../../../utils/helpers";

@connect(mapStateToProps)
export default class SaveRecursiveAppointmentConfirmationModal extends Component {
  constructor(props) {
    super(props);
  }

  closeApp = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close"
      }
    });
    window.dispatchEvent(event);
  };

  closeAndSave = applyto => {
    let {
      advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
      appointmentStepDataBeforeUserHasMadeAnyChanges,
      customerProfileData,
      apiCustomerProfileData,
      currentBookingId,
      appointmentStepData,
      advancedAppointmentStepData,
      closeAppWhenRecursiveAppointmentModalCloses,
      gotValidOffer,
      isMultiServiceAppointment,
      advancedAppointmentStepDataFromLastSave
    } = this.props;
    let {
      selectedTimeBeforeWeOverrodeRecurringAppointment,
      selectedDateBeforeWeOverrodeRecurringAppointment,
      selectedDate,
      selectedTime
    } = appointmentStepData;

    let payload = {};
    if (applyto && applyto === "thisonly") {
      payload = { applyto: "thisonly" };
      advancedAppointmentStepData.recurringToggleOn = false; // disable recurring to avoid creating a second-timeline
    } else if (applyto && applyto === "thisandfuture") {
      payload = { applyto: "thisandfuture" };
    }
    payload.status = appointmentStepData.selectedAppointmentStatus.id;
    let cb = () => {
      if (closeAppWhenRecursiveAppointmentModalCloses) {
        this.closeApp();
      } else {
        this.closeModal();
      }
    };
    let oldStartTime = null;
    let currentStartTime = null;
    if (
      selectedTimeBeforeWeOverrodeRecurringAppointment &&
      selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue
    ) {
      oldStartTime = toApiDateTime(
        selectedDateBeforeWeOverrodeRecurringAppointment,
        selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue,
        appointmentStepData.timeList
      );
    }

    currentStartTime = toApiDateTime(
      appointmentStepData.multiServiceList[0].selectedDate,
      appointmentStepData.multiServiceList[0].selectedTime.stringValue,
      appointmentStepData.timeList
    );

    let startTimeBeforeChanges = toApiDateTime(
      appointmentStepDataBeforeUserHasMadeAnyChanges.multiServiceList[0]
        .selectedDate,
      appointmentStepDataBeforeUserHasMadeAnyChanges.multiServiceList[0]
        .selectedTime.stringValue,
      appointmentStepData.timeList
    );

    let startTimeAfterChanges = toApiDateTime(
      appointmentStepData.multiServiceList[0].selectedDate,
      appointmentStepData.multiServiceList[0].selectedTime.stringValue,
      appointmentStepData.timeList
    );

    let draggedAndDroppedTimes = toApiDateTime(
      appointmentStepData.selectedDateBeforeWeOverrodeRecurringAppointment,
      appointmentStepData.selectedTimeBeforeWeOverrodeRecurringAppointment
        .stringValue,
      appointmentStepData.timeList
    );

    if (
      this.isCurrentAppointmentFirstInTheSeriesOfRecurring() &&
      applyto == "thisonly"
    ) {
      if (
        appointmentStepData.triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot &&
        startTimeAfterChanges != draggedAndDroppedTimes
      ) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            oldStartTime,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      } else if (startTimeBeforeChanges == startTimeAfterChanges) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            null,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      } else {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            oldStartTime,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      }
    } else if (currentBookingId && applyto == "thisandfuture") {
      //this old start time is required because of how recurring works, if we dont pass it the appointment will collide with itself
      this.props.dispatch(
        updateBooking(
          appointmentStepData,
          advancedAppointmentStepData,
          currentBookingId,
          payload.status,
          payload.applyto,
          cb,
          isMultiServiceAppointment,
          gotValidOffer,
          oldStartTime,
          advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
        )
      );
    } else {
      //when date is different we do splitfrom
      payload.applyto = "thisonly";
      advancedAppointmentStepData.recurringToggleOn = false;

      if (
        appointmentStepData.triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot &&
        startTimeAfterChanges != draggedAndDroppedTimes
      ) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            oldStartTime,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      } else if (startTimeBeforeChanges == startTimeAfterChanges) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            null,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      } else {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            oldStartTime,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      }
    }
  };

  isCurrentAppointmentFirstInTheSeriesOfRecurring = () => {
    let {
      bookingTimesUsedForRecurring,
      timeList,
      selectedDateBeforeWeOverrodeRecurringAppointment,
      selectedTimeBeforeWeOverrodeRecurringAppointment,
      triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot
    } = this.props.appointmentStepData;

    let isFirstInTheSeries = true;

    if (
      bookingTimesUsedForRecurring &&
      selectedTimeBeforeWeOverrodeRecurringAppointment &&
      selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue
    ) {
      let foundIndex = -1;
      bookingTimesUsedForRecurring.map((o, index) => {
        let convertedTime = convertApiUtcToLocalMoment(
          o.slotstarttime,
          window.userTimezone
        );
        let newTime = convertTimeFromApi(convertedTime);
        let newDate = convertDateTimeFromApi(convertedTime);
        let dateOnWhichAppointmentWasOpened = toApiDateTime(
          selectedDateBeforeWeOverrodeRecurringAppointment,
          selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue,
          timeList
        );
        let serverDateConvertedToLocalTime = toApiDateTime(
          newDate,
          newTime.stringValue,
          timeList
        );
        if (serverDateConvertedToLocalTime == dateOnWhichAppointmentWasOpened) {
          selectedDateBeforeWeOverrodeRecurringAppointment = newDate;
          selectedTimeBeforeWeOverrodeRecurringAppointment = newTime;
          foundIndex = index;
        }
      });
      if (foundIndex != 0) {
        isFirstInTheSeries = false;
      }
    }
    return isFirstInTheSeries;
  };

  closeModal = () => {
    let visible = false;
    this.props.dispatch(
      updateRecurringAppointmentConfirmationModalVisibility(visible)
    );
  };

  render() {
    let {
      recursiveAppointmentConfirmationModalVisible,
      savingBooking,
      loadingBooking
    } = this.props;
    let {
      bookingTimesUsedForRecurring,
      timeList,
      selectedDateBeforeWeOverrodeRecurringAppointment,
      selectedTimeBeforeWeOverrodeRecurringAppointment,
      triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot
    } = this.props.appointmentStepData;

    if (!recursiveAppointmentConfirmationModalVisible) {
      return "";
    }

    let discardChangesAndGoBack = () => {
      this.closeModal();
      this.closeApp();
      this.props.dispatch(updateGlobalErrorMessage(""));
    };

    //this is how we know if the current appointment is the first in the series or not
    let showThisAndFutureOption = true;

    let saveThisOnlyButtonClasses = "ui button savebtn this-only";
    let saveAllButtonClasses = "ui button savebtn all-recurring";
    let discardButtonClasses = "ui button cancel-btn";
    let {
      No,
      SaveThisOnly,
      SaveThisAndFuture,
      SaveChangesRecursiveAppointmentModal
    } = window.APP.LANGUAGE.Shared.PopupWindows;
    let {
      SaveRecurringAppTextThisOnly,
      SaveRecurringAppText
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;
    if (savingBooking || loadingBooking) {
      saveThisOnlyButtonClasses += " disabled";
      saveAllButtonClasses += " disabled";
      discardButtonClasses += " disabled";
    }

    return (
      <Modal
        className="bookingdetails-model save-recursive-appointment-confirmation transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div
            className={`save-box ${
              showThisAndFutureOption
                ? "save-recurring"
                : "save-recurring-this-only-option"
            }`}
          >
            <section className="header">
              {SaveChangesRecursiveAppointmentModal}
              <p className="save_text">
                {showThisAndFutureOption
                  ? SaveRecurringAppText
                  : SaveRecurringAppTextThisOnly}
              </p>
              {triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot ? (
                ""
              ) : (
                <button
                  type="button"
                  className="close_button"
                  onClick={this.closeModal}
                ></button>
              )}
            </section>
            <section className="save_box_buttons">
              <div
                className={discardButtonClasses}
                onClick={discardChangesAndGoBack}
              >
                {No}
              </div>
              <div
                className={saveThisOnlyButtonClasses}
                onClick={this.closeAndSave.bind(this, "thisonly")}
              >
                {SaveThisOnly}
              </div>
              {showThisAndFutureOption ? (
                <div
                  className={saveAllButtonClasses}
                  onClick={this.closeAndSave.bind(this, "thisandfuture")}
                >
                  {SaveThisAndFuture}
                </div>
              ) : (
                ""
              )}
            </section>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    recursiveAppointmentConfirmationModalVisible:
      state.menuReducer.recursiveAppointmentConfirmationModalVisible,
    savingBooking: state.bookingReducer.savingBooking,
    loadingBooking: state.bookingReducer.loadingBooking,
    advancedAppointmentStepDataFromLastSave:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataFromLastSave,
    appointmentStepDataBeforeUserHasMadeAnyChanges:
      state.appointmentStepReducer
        .appointmentStepDataBeforeUserHasMadeAnyChanges,
    closeAppWhenRecursiveAppointmentModalCloses:
      state.menuReducer.closeAppWhenRecursiveAppointmentModalCloses,
    apiCustomerProfileData: state.customerProfileReducer.apiCustomerProfileData,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    advancedAppointmentStepDataBeforeUserHasMadeAnyChanges:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
    isMultiServiceAppointment: state.bookingReducer.isMultiServiceAppointment,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    currentBookingId: state.bookingReducer.currentBookingId,
    locationToGoToFromCustomerPageModal:
      state.menuReducer.locationToGoToFromCustomerPageModal,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData
  };
}
